<template>
    <v-card>
        <v-card-title>
            <div class="mr-3">{{ $t('event.room') }}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{ $t('Cancel') }}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{ $t('Save') }}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{ $t('Reorder') }}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddRoom">
                {{ $t('add') }}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="tableRoom" :loading="isRoomPending" @pagination="currentPagination">
            <template v-slot:item.scroller="{ value }">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon><v-icon>drag_handle{{ value }}</v-icon></v-btn>
                </div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.order="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode" @click="initEditRoom(item)">
                    {{ $t('edit') }}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                    @click="deleteRoom(item)">
                    {{ $t('delete') }}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="editRoomDialogShown" max-width="600px" persistent scrollable :retain-focus="false">
            <v-card>
                <v-card-title>
                    {{ $t('event.room') }}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditRoomFormValid">
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.key')"
                                        :placeholder="$t('event_room.key')" v-model="editingRoom.key"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.name')"
                                        :placeholder="$t('event_room.name')"
                                        v-model="editingRoom.name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.name_tc')"
                                        :placeholder="$t('event_room.name_tc')"
                                        v-model="editingRoom.name_tc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.name_sc')"
                                        :placeholder="$t('event_room.name_sc')"
                                        v-model="editingRoom.name_sc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.address')"
                                        :placeholder="$t('event_room.address')"
                                        v-model="editingRoom.address"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.address_tc')"
                                        :placeholder="$t('event_room.address_tc')"
                                        v-model="editingRoom.address_tc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.address_sc')"
                                        :placeholder="$t('event_room.address_sc')"
                                        v-model="editingRoom.address_sc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.opening_hours')"
                                        :placeholder="$t('event_room.opening_hours')"
                                        v-model="editingRoom.opening_hours"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.opening_hours_tc')"
                                        :placeholder="$t('event_room.opening_hours_tc')"
                                        v-model="editingRoom.opening_hours_tc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.opening_hours_sc')"
                                        :placeholder="$t('event_room.opening_hours_sc')"
                                        v-model="editingRoom.opening_hours_sc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.start_time')"
                                        :placeholder="$t('event_room.start_time')"
                                        v-model="editingRoom.start_time"></v-text-field>
                                </v-col>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.end_time')"
                                        :placeholder="$t('event_room.end_time')"
                                        v-model="editingRoom.end_time"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_room.remarks')"
                                        :placeholder="$t('event_room.remarks')"
                                        v-model="editingRoom.remarks"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{ $t('cancel') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="confirmSaveItemDialogShown = true"
                        :disabled="!isEditRoomFormValid">{{ $t('save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <PopupAlert v-model="confirmCancelItemDialogShown" title="Warning"
            message="Do you wish to cancel your amendments?" :onYes="cancelEditRoomItem"
            :onNo="function () { confirmCancelItemDialogShown = false; }"></PopupAlert>
        <PopupAlert v-model="confirmSaveItemDialogShown" title="Confirm"
            message="Do you wish to confirm to save your room?" :onYes="saveRoom"
            :onNo="function () { confirmSaveItemDialogShown = false; }"></PopupAlert>
    </v-card>
</template>

<style scoped>
    .button-spacer {
        width: 10px;
    }
</style>

<script>
import { computed, ref, onMounted } from "@vue/composition-api";
import { useFind } from "feathers-vuex";
import { DateTime } from "luxon";
import { cloneDeep } from "lodash";
import PopupAlert from "../../components/PopupAlert";
import Sortable from "sortablejs";

export default {
    name: 'EventRoom',
    components: { PopupAlert },
    setup(props, { root }) {
        const { EventRoom } = root.$FeathersVuex.api;

        const eventId = computed(() => root.$route.params.eventId);

        const roomParams = computed(() => {
            return {
                query: {
                    eventId: eventId.value
                }
            }
        });
        const { items: roomItems, isPending: isRoomPending } = useFind({
            model: EventRoom,
            params: roomParams,
        });
        // Data Table
        const headers = ref([
            { text: '', value: 'scroller', width: 80 },
            { text: root.$t('event_room.order'), value: 'order' },
            { text: root.$t('event_room.key'), value: 'key' },
            { text: root.$t('event_room.name'), value: 'name' },
            { text: root.$t('event_room.address'), value: 'address' },
            { text: root.$t('event_room.opening_hours'), value: 'opening_hours' },
            { text: root.$t('event_room.remarks'), value: 'remarks' },
            { text: '', value: 'actions' },
        ]);

        // Order
        const isEditOrderMode = ref(false);
        const didOrderChange = ref(false);
        const editOrderRoom = ref([]);
        const overlay = ref(false);

        // Add / Edit
        const editRoomDialogShown = ref(false);
        const confirmCancelItemDialogShown = ref(false);
        const confirmSaveItemDialogShown = ref(false);
        const isEditRoomFormValid = ref(false);
        const editingRoom = ref(new EventRoom({ eventId: eventId.value }));
        const initAddRoom = function () {
            editingRoom.value = new EventRoom({ eventId: eventId.value });
            editingRoom.value.order = roomItems.value.length + 1;
            editRoomDialogShown.value = true;
        };
        const initEditRoom = function (room) {
            editingRoom.value = cloneDeep(room);
            editRoomDialogShown.value = true;
        };
        const deleteRoom = function (room) {
            if (confirm(root.$t('event_room.confirm_delete'))) {
                room.remove();
            }
        };
        const saveRoom = async function () {
            editingRoom.value.save().then(() => {
                EventRoom.get(editingRoom.value.id);
                editRoomDialogShown.value = false;
                confirmSaveItemDialogShown.value = false;
                root.$store.dispatch('showSnackBar', root.$t('event_room.save_successful'));
            }, root.$handleFeatherError.bind(root));
        };

        const previewHtmlContentOption = {
            modules: {
                toolbar: false,
            },
            placeholder: '',
            theme: 'bubble',
        };

        const cancelEditRoomItem = function () {
            editRoomDialogShown.value = false;
            confirmCancelItemDialogShown.value = false;
        }

        const initEditOrder = function () {
            didOrderChange.value = false
            isEditOrderMode.value = true
            editOrderRoom.value = cloneDeep(sortedRoom.value)
        }

        const saveEditOrder = async function () {
            if (!didOrderChange.value) {
                isEditOrderMode.value = false
                return;
            }

            overlay.value = true
            for (let i = 0; i < editOrderRoom.value.length; i++) {
                await editOrderRoom.value[i].save().then(() => {
                    EventRoom.get(editOrderRoom.value[i].id)
                })
            }
            isEditOrderMode.value = false
            overlay.value = false
        }

        const cancelEditOrder = function () {
            isEditOrderMode.value = false
        }
        const quickSortRoom = function (sortRoom) {
            if (sortRoom.length < 2) {
                return sortRoom
            }

            const chosenIndex = sortRoom.length - 1
            const chosen = sortRoom[chosenIndex]
            const a = []
            const b = []
            for (let i = 0; i < chosenIndex; i++) {
                const temp = sortRoom[i].order
                temp < chosen.order ? a.push(sortRoom[i]) : b.push(sortRoom[i])
            }
            const output = [...quickSortRoom(a), chosen, ...quickSortRoom(b)]
            return output
        }

        const sortedRoom = computed(() => {
            return quickSortRoom(roomItems.value)
        })
        const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
        const currentPagination = function (e) { // Update current page
            currentStart.value = e.pageStart
        }
        onMounted(() => {
            let table = document.querySelector('.v-data-table tbody');
            Sortable.create(table,
                {
                    handle: ".handle", // Look for class with name "handle"
                    onEnd({ newIndex, oldIndex }) {
                        didOrderChange.value = true;
                        newIndex += currentStart.value;
                        oldIndex += currentStart.value;
                        const rowSelected = editOrderRoom.value.splice(oldIndex, 1)[0];
                        editOrderRoom.value.splice(newIndex, 0, rowSelected);

                        for (let i = 0; i < editOrderRoom.value.length; i++) {
                            editOrderRoom.value[i].order = i + 1
                        }
                        editOrderRoom.value = quickSortRoom(editOrderRoom.value);
                    }
                }
            )
        });

        const tableRoom = computed(() => {
            return isEditOrderMode.value ? editOrderRoom.value : sortedRoom.value
        })

        return {
            roomItems,
            isRoomPending,

            headers,
            tableRoom,

            editRoomDialogShown,
            confirmCancelItemDialogShown,
            confirmSaveItemDialogShown,
            initAddRoom,
            initEditRoom,
            deleteRoom,
            isEditRoomFormValid,
            editingRoom,
            saveRoom,
            cancelEditRoomItem,

            DateTime,
            getFileUrl: root.$getFileURL,

            previewHtmlContentOption,
            currentPagination,

            initEditOrder,
            saveEditOrder,
            cancelEditOrder,

            isEditOrderMode,
            overlay,
        }
    }
}
</script>
